import { $crud } from "./CrudFactory";

let isPrompting = false;

function findDiscardButton(paper, discardLabel) {
  const buttons = [...(paper.querySelectorAll(".MuiDialogActions-root .MuiButton-root") || [])];
  return (
    buttons.find((b) => b.textContent.trim() === discardLabel) ||
    buttons.find((b) => !b.classList.contains("MuiButton-textPrimary"))
  );
}

function dismissConfirm(paper, discardLabel) {
  const discardBtn = findDiscardButton(paper, discardLabel);
  if (discardBtn) discardBtn.click();
}

/**
 * Ask whether to save the current compose as a draft.
 * Returns "save" | "discard" | "stay".
 */
export async function promptSaveDraft(strings = {}) {
  if (isPrompting) return "stay";
  isPrompting = true;
  const saveLabel = strings.email_save_draft || "Save Draft";
  const discardLabel = strings.email_discard || "Discard";
  const backLabel = strings.email_back_to_compose || "Back to compose";
  let choice = "stay";

  const patchConfirmDialog = () => {
    const paper = document.querySelector(".MuiDialog-root .MuiPaper-root");
    if (!paper) {
      setTimeout(patchConfirmDialog, 50);
      return;
    }

    paper.style.position = "relative";
    paper.classList.add("email-draft-confirm");

    if (!paper.querySelector(".email-confirm-close-x")) {
      const closeBtn = document.createElement("button");
      closeBtn.className = "email-confirm-close-x";
      closeBtn.type = "button";
      closeBtn.setAttribute("aria-label", backLabel);
      closeBtn.innerHTML =
        '<span class="material-symbols-outlined" style="font-size:18px">close</span>';
      closeBtn.onclick = (e) => {
        e.stopPropagation();
        choice = "stay";
        dismissConfirm(paper, discardLabel);
      };
      paper.insertBefore(closeBtn, paper.firstChild);
    }

    const discardBtn = findDiscardButton(paper, discardLabel);
    if (discardBtn && !discardBtn.dataset.emailDraftBound) {
      discardBtn.dataset.emailDraftBound = "1";
      discardBtn.addEventListener(
        "mousedown",
        () => {
          choice = "discard";
        },
        { capture: true }
      );
    }
  };

  try {
    document.body.setAttribute("data-confirm-color", "violet");
    setTimeout(patchConfirmDialog, 50);
    await $crud.confirm({
      title: "",
      textContent:
        strings.email_save_draft_confirm ||
        "Do you want to save this email as a draft?",
      options: {
        ok: saveLabel,
        cancel: discardLabel,
      },
    });
    document.body.removeAttribute("data-confirm-color");
    return "save";
  } catch {
    document.body.removeAttribute("data-confirm-color");
    return choice === "discard" ? "discard" : "stay";
  } finally {
    isPrompting = false;
  }
}
